window.Reverb = window.Reverb || {};

Reverb.Address = (function () {
  function init() {
    bindCountrySelectProgressiveDisclosure();
    changeRegionDropDownOnCountryChange();
  }

  function bindCountrySelectProgressiveDisclosure() {
    $(document).on('click', 'a[data-bind=\'change-country\']', function (e) {
      e.preventDefault();
      $(this).hide();
      $(this).siblings('[data-bind=\'hide-with-change-country\']').hide();
      $(this).siblings('[data-bind=\'change-country-select\']').fadeIn();
    });
  }

  function changeRegionDropDownOnCountryChange() {
    $(document).on('change', 'select[data-bind=\'country-select\']', function () {
      const country_select = $(this);
      const address_fields = $(this).closest('[data-address-fields]');
      const select_wrapper = address_fields.find('[data-state-wrapper]');
      const region_select = select_wrapper.find('select');

      const country_code = country_select.val();
      const field_prefix = country_select.data('field-prefix');
      const field_name = country_select.data('region-field-name');
      const region_required = $(select_wrapper).data('region-required');
      const shipping_estimate_field = region_select.data('shipping-estimate-field');

      // The params specified here are passed into the controller so that when
      // it re-renders the partial via ajax, all its original params are retained.
      const url = `/addresses/subregion_options?${$.param({
        parent_region: country_code,
        field_prefix,
        field_name,
        region_required,
        shipping_estimate_field,
      })}`;

      $('select', select_wrapper).attr('disabled', true);
      $.get(url, (data) => {
        select_wrapper.replaceWith(data);
        country_select.trigger('regions_updated');
      });
    });
  }

  return {
    init,
  };
}());

$(() => {
  Reverb.Address.init();
});
